import { styled } from 'solid-styled-components';
import theme from '../../style/theme';

export const StyledLoadingContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export const StyledNoCoursesSection = styled.div`
    background-color: ${theme.palette.white};
    padding: 3rem;
    margin-block: 2rem;
    border-radius: ${theme.borderRadius.large};
    display: flex;
    flex-direction: column;
    gap: 1rem;

    ${theme.containerQueries.mobileMax} {
        padding: 2rem;
        margin-block: 1rem;
        gap: 1.5rem;
    }

    ${theme.mediaQueries.mobileMax} {
        border-radius: ${theme.borderRadius.small};
    }
`;

export const StyledNoCoursesSectionInner = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3.5rem;
    max-width: 65rem;
`;


export const StyledHeadingContainer = styled.div`
    margin-bottom: 0.25em;
`;
